







import Vue from "vue";
import TextContent from "@/components/Text/TextContent.vue";
export default Vue.extend({
  name: "Paragraph",
  props: {
    color: {
      type: String,
      default: "var(--quaternary-color)"
    },
    fontSize: {
      type: String,
      default: "16px"
    }
  },
  components: { TextContent }
});
